import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { FormState, NgrxFormsModule } from 'ngrx-forms';
import { TrackFieldfocusDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  ValidationClassesDirective,
  AutocompleteDirective,
  HasValueDirective,
} from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  standalone: true,
  imports: [
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    AutocompleteDirective,
    HasValueDirective,
    TrackFieldfocusDirective,
    AutomationIdDirective,
    CommonUiUtilityComponentsModule,
  ],
})
export class EmailComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() placeholder = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() preventPaste = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() skipDirtyCheck = false;

  onPaste(event: ClipboardEvent) {
    if (this.preventPaste) {
      event.preventDefault();
    }
  }
}
